export default "__VITE_ASSET__CRvj7OgH__"